import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const totalPriceFooter: ThemeApp['appComponents']['totalPriceFooter'] = {
  borderTop: `1px solid ${themeUi.semantic.color.border.secondary300}`
};

export default totalPriceFooter;
